<template>
  <el-table-column
    prop="supplier_name"
    label="Beszállító"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.supplier_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'supplier_name',
};
</script>
